var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 84,
    viewBox: "0 0 73 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1711_29457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3608 1.5C48.6646 10.2152 60.4557 13.8038 71.2215 15.8544V42C71.2215 61.481 58.4051 74.2975 36.3608 82.5C14.3165 74.2975 1.5 61.481 1.5 42V15.8544C12.2658 13.8038 24.057 10.2152 36.3608 1.5Z",
    stroke: "#11151B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1711_29457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 41.5L33.8333 46.537L45.1667 34.5741M18.5 41.5C18.5 43.7325 18.9656 45.9431 19.8702 48.0056C20.7748 50.0682 22.1006 51.9422 23.7721 53.5208C25.4435 55.0994 27.4278 56.3516 29.6117 57.206C31.7956 58.0603 34.1362 58.5 36.5 58.5C38.8638 58.5 41.2044 58.0603 43.3883 57.206C45.5722 56.3516 47.5565 55.0994 49.2279 53.5208C50.8994 51.9422 52.2252 50.0682 53.1298 48.0056C54.0344 45.9431 54.5 43.7325 54.5 41.5C54.5 39.2675 54.0344 37.0569 53.1298 34.9944C52.2252 32.9318 50.8994 31.0578 49.2279 29.4792C47.5565 27.9006 45.5722 26.6484 43.3883 25.794C41.2044 24.9397 38.8638 24.5 36.5 24.5C34.1362 24.5 31.7956 24.9397 29.6117 25.794C27.4278 26.6484 25.4435 27.9006 23.7721 29.4792C22.1006 31.0578 20.7748 32.9318 19.8702 34.9944C18.9656 37.0569 18.5 39.2675 18.5 41.5Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1711_29457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 84,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1711_29457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 37,
    fill: "white",
    transform: "translate(17 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.4828f610ebbe7d7ca03799c77a4ef668.svg";
export { ForwardRef as ReactComponent };